// extracted by mini-css-extract-plugin
module.exports = {"bottom":"Icon_bottom__jRTrA","right":"Icon_right__pMwnU"};